import React from "react";
import { Outlet } from "react-router";
import { PageShell } from "@sscs/ui";
import SettingsNavigation from "../../components/SettingsNavigation/SettingsNavigation";
import styles from "./userSettings.module.scss";

type UserSettingsLayoutProps = {
  isSSOLogin: boolean;
  handleNavigate: (selected: string) => void;
  selected: string;
};

const UserSettingsLayout = ({
  isSSOLogin,
  handleNavigate,
  selected,
}: UserSettingsLayoutProps): React.JSX.Element => {
  return (
    <PageShell
      sidebar={
        <SettingsNavigation
          selected={selected}
          onClick={handleNavigate}
          hideChangePasswordLink={isSSOLogin}
        />
      }
      contentClassName={styles.content}
    >
      <Outlet />
    </PageShell>
  );
};

export default UserSettingsLayout;
